/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import styled from "@emotion/styled";

import AppsIcon from "@material-ui/icons/Apps";
import Popover from "@material-ui/core/Popover";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import VerticalAlignCenterIcon from "@material-ui/icons/VerticalAlignCenter";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";

import CloseIcon from "@material-ui/icons/Close";
import ToolbarButton from "./ToolbarButton";
import t from "translations";

const SetPositionButton = (props) => {
  const { canvas } = props;
  //popover
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isPopoverOpened = Boolean(anchorEl);
  const popoverID = isPopoverOpened ? "position-popover" : undefined;

  const centerActiveObject = (vertically, horizontally) => {
    let ao = canvas.getActiveObject();

    if (vertically) {
      ao.setPositionByOrigin(
        { x: ao.left, y: canvas.backgroundImage.height / 2 },
        "left",
        "center"
      );
    }
    if (horizontally) {
      ao.setPositionByOrigin(
        { x: canvas.backgroundImage.width / 2, y: ao.top },
        "center",
        "top"
      );
    }

    ao.setCoords();
    canvas.requestRenderAll();
  };

  const moveActiveObject = (position) => {
    let ao = canvas.getActiveObject();
    //console.log(canvas.backgroundImage, ao);

    switch (position) {
      case "topleft":
        ao.top = 0;
        ao.left = 0;
        break;
      case "topcent":
        ao.top = 0;
        ao.viewportCenterH();
        break;
      case "topright":
        ao.top = 0;
        ao.left = canvas.backgroundImage.width - ao.width * ao.scaleX;
        break;
      case "midleft":
        ao.viewportCenterV();
        ao.left = 0;
        break;
      case "midright":
        ao.viewportCenterV();
        ao.left = canvas.backgroundImage.width - ao.width * ao.scaleX;
        break;
      case "botleft":
        ao.top = canvas.backgroundImage.height - ao.height * ao.scaleY;
        ao.left = 0;
        break;
      case "botcent":
        ao.top = canvas.backgroundImage.height - ao.height * ao.scaleY;
        ao.viewportCenterH();
        break;
      case "botright":
        ao.top = canvas.backgroundImage.height - ao.height * ao.scaleY;
        ao.left = canvas.backgroundImage.width - ao.width * ao.scaleX;
        break;
      default:
        break;
    }

    ao.setCoords();
    canvas.requestRenderAll();
  };

  const PopupDlg = styled.div`
    padding: 10px;
    width: 169px;
  `;
  const PopupHeader = styled.div`
    align-items: center;
    justify-content: space-between;
    display: flex;
  `;
  const CloseBtn = styled.div`
    cursor: pointer;
    padding: 0;
    margin: 0;
    opacity: 0.5;
    :hover {
      opacity: 1;
    }
  `;
  const FirstRow = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
  `;

  return (
    <div id="setpositionbtn">
      <ToolbarButton
        desc={t.position}
        tooltip
        icon={<AppsIcon />}
        aria-describedby={popoverID}
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      />
      <Popover
        id={popoverID}
        open={isPopoverOpened}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <PopupDlg>
          <PopupHeader>
            <Typography variant="caption">{t.popuptitle}</Typography>
            <CloseBtn>
              <CloseIcon
                onClick={() => {
                  setAnchorEl(null);
                }}
              />
            </CloseBtn>
          </PopupHeader>
          <FirstRow>
            <ToolbarButton
              desc={t.centerv}
              tooltip
              icon={<VerticalAlignCenterIcon />}
              onClick={() => {
                centerActiveObject(1, 0);
              }}
            />
            <ToolbarButton
              desc={t.centerh}
              tooltip
              icon={
                <VerticalAlignCenterIcon
                  css={css`
                    transform: rotate(90deg);
                  `}
                />
              }
              onClick={() => {
                centerActiveObject(0, 1);
              }}
            />
          </FirstRow>
          <Divider />
          <Grid container spacing={1}>
            <ToolbarButton
              desc={t.postopleft}
              tooltip
              icon={
                <ArrowUpwardIcon
                  css={css`
                    transform: rotate(-45deg);
                  `}
                />
              }
              onClick={() => {
                moveActiveObject("topleft");
              }}
            />
            <ToolbarButton
              desc={t.postopcenter}
              tooltip
              icon={<ArrowUpwardIcon />}
              onClick={() => {
                moveActiveObject("topcent");
              }}
            />
            <ToolbarButton
              desc={t.postopright}
              tooltip
              icon={
                <ArrowUpwardIcon
                  css={css`
                    transform: rotate(45deg);
                  `}
                />
              }
              onClick={() => {
                moveActiveObject("topright");
              }}
            />
            <ToolbarButton
              desc={t.posmidleft}
              tooltip
              icon={<ArrowBackIcon />}
              onClick={() => {
                moveActiveObject("midleft");
              }}
            />
            <ToolbarButton
              desc={t.posmidcenter}
              tooltip
              icon={<RadioButtonUncheckedIcon />}
              onClick={() => {
                centerActiveObject(1, 1);
              }}
            />
            <ToolbarButton
              desc={t.posmidright}
              tooltip
              icon={<ArrowForwardIcon />}
              onClick={() => {
                moveActiveObject("midright");
              }}
            />
            <ToolbarButton
              desc={t.posbotleft}
              tooltip
              icon={
                <ArrowDownwardIcon
                  css={css`
                    transform: rotate(45deg);
                  `}
                />
              }
              onClick={() => {
                moveActiveObject("botleft");
              }}
            />
            <ToolbarButton
              desc={t.posbotcenter}
              tooltip
              icon={<ArrowDownwardIcon />}
              onClick={() => {
                moveActiveObject("botcent");
              }}
            />
            <ToolbarButton
              desc={t.posbotright}
              tooltip
              icon={
                <ArrowDownwardIcon
                  css={css`
                    transform: rotate(-45deg);
                  `}
                />
              }
              onClick={() => {
                moveActiveObject("botright");
              }}
            />
          </Grid>
        </PopupDlg>
      </Popover>
    </div>
  );
};

export default SetPositionButton;
